import React from 'react';
import { SearchXIcon } from 'lucide-react';
import { Button } from './Button';
type EmptyStateProps = {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
};
export function EmptyState({
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center rounded-media border border-dashed border-sand-300 bg-white px-6 py-16 text-center" data-id="element-595" data-mp="1sf3k6r9mr3o8">
      <SearchXIcon aria-hidden className="h-8 w-8 text-slate-500" data-id="element-596" data-mp="vpma803m6vgq" />
      <h3 className="mt-4 font-display text-[22px] text-ink" data-id="element-597" data-mp="10mw2dnie1l89">{title}</h3>
      <p className="mt-2 max-w-md text-[15px] leading-relaxed text-slate-600" data-id="element-598" data-mp="14p0w0m8u6huw">{description}</p>
      {actionLabel && onAction && <Button variant="secondary" className="mt-6" onClick={onAction} data-id="element-599" data-mp="19fzcpmxqlhyo">
          {actionLabel}
        </Button>}
    </div>;
}